/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ConversationCreateRequest,
  ConversationDto,
  ConversationUpdateRequest,
  ConversationUpdateResponse,
  GetConversationsParams,
  MessageFeedbackRequest,
  MessageRegenerateRequest,
  MessageRequest,
  ServerSentEventStreamEventDto,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **Any authenticated role**
 */
export const updateConversation = (
  oktaUserId: string,
  conversationId: string,
  conversationUpdateRequest: BodyType<ConversationUpdateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConversationUpdateResponse>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: conversationUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateConversationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConversation>>,
    TError,
    {
      oktaUserId: string;
      conversationId: string;
      data: BodyType<ConversationUpdateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    data: BodyType<ConversationUpdateRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateConversation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConversation>>,
    {
      oktaUserId: string;
      conversationId: string;
      data: BodyType<ConversationUpdateRequest>;
    }
  > = (props) => {
    const { oktaUserId, conversationId, data } = props ?? {};

    return updateConversation(oktaUserId, conversationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConversation>>
>;
export type UpdateConversationMutationBody =
  BodyType<ConversationUpdateRequest>;
export type UpdateConversationMutationError = ErrorType<unknown>;

export const useUpdateConversation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateConversation>>,
      TError,
      {
        oktaUserId: string;
        conversationId: string;
        data: BodyType<ConversationUpdateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    data: BodyType<ConversationUpdateRequest>;
  },
  TContext
> => {
  return useMutation(
    getUpdateConversationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const deleteConversation = (
  oktaUserId: string,
  conversationId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteConversationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversation>>,
    TError,
    { oktaUserId: string; conversationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { oktaUserId: string; conversationId: string },
  TContext
> => {
  const mutationKey = ['deleteConversation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConversation>>,
    { oktaUserId: string; conversationId: string }
  > = (props) => {
    const { oktaUserId, conversationId } = props ?? {};

    return deleteConversation(oktaUserId, conversationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConversation>>
>;

export type DeleteConversationMutationError = ErrorType<unknown>;

export const useDeleteConversation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteConversation>>,
      TError,
      { oktaUserId: string; conversationId: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { oktaUserId: string; conversationId: string },
  TContext
> => {
  return useMutation(
    getDeleteConversationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const regenerateConversationMessage = (
  oktaUserId: string,
  conversationId: string,
  messageId: string,
  messageRegenerateRequest?: BodyType<MessageRegenerateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ServerSentEventStreamEventDto[]>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}/messages/${messageId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: messageRegenerateRequest,
      signal,
    },
    options
  );
};

export const getRegenerateConversationMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateConversationMessage>>,
    TError,
    {
      oktaUserId: string;
      conversationId: string;
      messageId: string;
      data?: BodyType<MessageRegenerateRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateConversationMessage>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    messageId: string;
    data?: BodyType<MessageRegenerateRequest>;
  },
  TContext
> => {
  const mutationKey = ['regenerateConversationMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateConversationMessage>>,
    {
      oktaUserId: string;
      conversationId: string;
      messageId: string;
      data?: BodyType<MessageRegenerateRequest>;
    }
  > = (props) => {
    const { oktaUserId, conversationId, messageId, data } = props ?? {};

    return regenerateConversationMessage(
      oktaUserId,
      conversationId,
      messageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateConversationMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateConversationMessage>>
>;
export type RegenerateConversationMessageMutationBody =
  | BodyType<MessageRegenerateRequest>
  | undefined;
export type RegenerateConversationMessageMutationError = ErrorType<unknown>;

export const useRegenerateConversationMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateConversationMessage>>,
      TError,
      {
        oktaUserId: string;
        conversationId: string;
        messageId: string;
        data?: BodyType<MessageRegenerateRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateConversationMessage>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    messageId: string;
    data?: BodyType<MessageRegenerateRequest>;
  },
  TContext
> => {
  return useMutation(
    getRegenerateConversationMessageMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const getConversations = (
  oktaUserId: string,
  params?: GetConversationsParams,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConversationDto[]>(
    { url: `/api/${oktaUserId}/conversations`, method: 'GET', params, signal },
    options
  );
};

export const getGetConversationsQueryKey = (
  oktaUserId: string,
  params?: GetConversationsParams
) => {
  return [
    `/api/${oktaUserId}/conversations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  params?: GetConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConversationsQueryKey(oktaUserId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversations>>
  > = ({ signal }) =>
    getConversations(oktaUserId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!oktaUserId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversations>>
>;
export type GetConversationsQueryError = ErrorType<unknown>;

export function useGetConversations<
  TData = Awaited<ReturnType<typeof getConversations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  params: undefined | GetConversationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversations>>,
          TError,
          Awaited<ReturnType<typeof getConversations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversations<
  TData = Awaited<ReturnType<typeof getConversations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  params?: GetConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversations>>,
          TError,
          Awaited<ReturnType<typeof getConversations>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversations<
  TData = Awaited<ReturnType<typeof getConversations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  params?: GetConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetConversations<
  TData = Awaited<ReturnType<typeof getConversations>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  params?: GetConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationsQueryOptions(
    oktaUserId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const createConversation = (
  oktaUserId: string,
  conversationCreateRequest: BodyType<ConversationCreateRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConversationDto>(
    {
      url: `/api/${oktaUserId}/conversations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: conversationCreateRequest,
      signal,
    },
    options
  );
};

export const getCreateConversationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConversation>>,
    TError,
    { oktaUserId: string; data: BodyType<ConversationCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { oktaUserId: string; data: BodyType<ConversationCreateRequest> },
  TContext
> => {
  const mutationKey = ['createConversation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConversation>>,
    { oktaUserId: string; data: BodyType<ConversationCreateRequest> }
  > = (props) => {
    const { oktaUserId, data } = props ?? {};

    return createConversation(oktaUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConversation>>
>;
export type CreateConversationMutationBody =
  BodyType<ConversationCreateRequest>;
export type CreateConversationMutationError = ErrorType<unknown>;

export const useCreateConversation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createConversation>>,
      TError,
      { oktaUserId: string; data: BodyType<ConversationCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { oktaUserId: string; data: BodyType<ConversationCreateRequest> },
  TContext
> => {
  return useMutation(
    getCreateConversationMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const getConversationById = (
  oktaUserId: string,
  conversationId: string,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ConversationDto>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}/messages`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetConversationByIdQueryKey = (
  oktaUserId: string,
  conversationId: string
) => {
  return [
    `/api/${oktaUserId}/conversations/${conversationId}/messages`,
  ] as const;
};

export const getGetConversationByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetConversationByIdQueryKey(oktaUserId, conversationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getConversationById>>
  > = ({ signal }) =>
    getConversationById(oktaUserId, conversationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && conversationId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversationById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversationById>>
>;
export type GetConversationByIdQueryError = ErrorType<unknown>;

export function useGetConversationById<
  TData = Awaited<ReturnType<typeof getConversationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  conversationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationById>>,
          TError,
          Awaited<ReturnType<typeof getConversationById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationById<
  TData = Awaited<ReturnType<typeof getConversationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversationById>>,
          TError,
          Awaited<ReturnType<typeof getConversationById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversationById<
  TData = Awaited<ReturnType<typeof getConversationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetConversationById<
  TData = Awaited<ReturnType<typeof getConversationById>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversationById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationByIdQueryOptions(
    oktaUserId,
    conversationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **Any authenticated role**
 */
export const sendConversationMessage = (
  oktaUserId: string,
  conversationId: string,
  messageRequest: BodyType<MessageRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<ServerSentEventStreamEventDto[]>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}/messages`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: messageRequest,
      signal,
    },
    options
  );
};

export const getSendConversationMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendConversationMessage>>,
    TError,
    {
      oktaUserId: string;
      conversationId: string;
      data: BodyType<MessageRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendConversationMessage>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    data: BodyType<MessageRequest>;
  },
  TContext
> => {
  const mutationKey = ['sendConversationMessage'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendConversationMessage>>,
    {
      oktaUserId: string;
      conversationId: string;
      data: BodyType<MessageRequest>;
    }
  > = (props) => {
    const { oktaUserId, conversationId, data } = props ?? {};

    return sendConversationMessage(
      oktaUserId,
      conversationId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SendConversationMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendConversationMessage>>
>;
export type SendConversationMessageMutationBody = BodyType<MessageRequest>;
export type SendConversationMessageMutationError = ErrorType<unknown>;

export const useSendConversationMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendConversationMessage>>,
      TError,
      {
        oktaUserId: string;
        conversationId: string;
        data: BodyType<MessageRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendConversationMessage>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    data: BodyType<MessageRequest>;
  },
  TContext
> => {
  return useMutation(
    getSendConversationMessageMutationOptions(options),
    queryClient
  );
};
/**
 * Authorities: **Any authenticated role**
 */
export const sendConversationMessageFeedback = (
  oktaUserId: string,
  conversationId: string,
  messageId: string,
  messageFeedbackRequest: BodyType<MessageFeedbackRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${oktaUserId}/conversations/${conversationId}/messages/${messageId}/feedback`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: messageFeedbackRequest,
      signal,
    },
    options
  );
};

export const getSendConversationMessageFeedbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendConversationMessageFeedback>>,
    TError,
    {
      oktaUserId: string;
      conversationId: string;
      messageId: string;
      data: BodyType<MessageFeedbackRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendConversationMessageFeedback>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    messageId: string;
    data: BodyType<MessageFeedbackRequest>;
  },
  TContext
> => {
  const mutationKey = ['sendConversationMessageFeedback'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendConversationMessageFeedback>>,
    {
      oktaUserId: string;
      conversationId: string;
      messageId: string;
      data: BodyType<MessageFeedbackRequest>;
    }
  > = (props) => {
    const { oktaUserId, conversationId, messageId, data } = props ?? {};

    return sendConversationMessageFeedback(
      oktaUserId,
      conversationId,
      messageId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SendConversationMessageFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendConversationMessageFeedback>>
>;
export type SendConversationMessageFeedbackMutationBody =
  BodyType<MessageFeedbackRequest>;
export type SendConversationMessageFeedbackMutationError = ErrorType<unknown>;

export const useSendConversationMessageFeedback = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendConversationMessageFeedback>>,
      TError,
      {
        oktaUserId: string;
        conversationId: string;
        messageId: string;
        data: BodyType<MessageFeedbackRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendConversationMessageFeedback>>,
  TError,
  {
    oktaUserId: string;
    conversationId: string;
    messageId: string;
    data: BodyType<MessageFeedbackRequest>;
  },
  TContext
> => {
  return useMutation(
    getSendConversationMessageFeedbackMutationOptions(options),
    queryClient
  );
};
